export const EVENT_LEVEL = {
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
  INTERNAL: 'internal',
};

export const ACTIONS = {
  CHAT: 'chat',
  IN_PRODUCT: 'in_product',
  DAILY_BLOCK: 'daily_block',
  POPUP: 'popup',
  CUSTOM_POPUP: 'custom_popup',
};

export const EVENT_TYPES = {
  TRACK: 'track',
  CONVERSION: 'conversion',
  TRIGGER: 'trigger',
  CTR: 'ctr',
};

export const ADDITIONAL_INFO = {
  VARIANT: 'variant',
  TIME: 'time',
};

export const CONVERSION_TYPES = {
  SIGNUP: 'signup',
  DEMO_REQUEST: 'demo_request',
  PURCHASE: 'purchase',
  DEMO_SUBSCRIPTION: 'demo_subscription',
};
